<script setup>
import StepComponent from './common/StepComponent.vue'

const stepItems = [
  {
    title: 'Checkout',
    text: 'Complete the checkout process to finalize your order.',
    id: 1,
    icon: 'fa-credit-card'
  },
  {
    title: 'Verify Business Details',
    text: 'Once checkout is completed, you will input your beneficial ownership details to complete your filing.',
    id: 2,
    icon: 'fa-file-check'
  },
  {
    title: 'Submit and Relax',
    text: 'Once all steps are completed, relax and let us handle the rest. We will notify you when your filing is complete.',
    id: 3,
    icon: 'fa-face-smile'
  }
]
</script>
<template>
  <div class="border-bottom pb-4 mb-4 text-center">
    <h3 class="card-header-title mb-4">What Happens Next?</h3>
    <StepComponent :stepItems="stepItems" />
  </div>
</template>
